import { Component, Input } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-block-title',
    templateUrl: './block-title.component.html',
    styleUrls: ['./block-title.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf]
})
export class BlockTitleComponent {
    @Input() title;
    @Input() description;
 
    constructor(public translationHelper: TranslateHelper) { }
}
